import React, { PropTypes } from 'react';
import moment from 'moment';
import DatePicker from 'react-datepicker';
import styles from './DatePickerComponent.css';

const handleChange = (date, props) => {
  const value = moment(date).format('MM/DD/YYYY');
  if (value !== 'Invalid date') {
    if (date instanceof moment) {
      props.onDateChange(date);
    } else {
      const formattedDate = moment(date);
      props.onDateChange(formattedDate);
    }
  } else if (date === null) {
    props.onDateChange(date);
  }
  const {
    replica,
    options,
    activeFilter,
    type,
    updateFilter,
    applyFilter,
  } = props;
  // the react select accepts the values in label value pair and inside and array.
  // [{label: 'value', 'value': value}]
  const formattedValue = {};
  formattedValue.label = value;
  formattedValue.value = value;
  const finalFilter = !date ? [] : [formattedValue];
  replica && replica(options); // eslint-disable-line
  activeFilter && activeFilter(type); // eslint-disable-line
  updateFilter && updateFilter(type, finalFilter).then(() => { // eslint-disable-line
    applyFilter && applyFilter(); // eslint-disable-line
  });
};

const handleRawChange = (data, props) => {
  const dateValue = data.target.value;
  const date = moment(dateValue).format('MM/DD/YYYY');
  handleChange(date, props);
};
let refPicker = null;

const clickOutside = () => {
  refPicker.cancelFocusInput();
  refPicker.setOpen(false);
};

const toggleClick = () => refPicker.setOpen(true);

const DatePickerComponent = props => (
  <div className={styles.datePickerUI}>
    <style>
      {`.react-datepicker-popper[data-placement^="bottom"] {
        margin-top: 10px;
        top: auto !important;
        left: auto !important;
        transform: none !important;
      }`}
    </style>
    <DatePicker
      selected={props.selected}
      maxDate={moment()}
      dateFormat={'MM/DD/YYYY'}
      dateFormatCalendar={'MM/DD/YYYY'}
      onChangeRaw={data => handleRawChange(data, props)}
      onChange={data => handleChange(data, props)}
      className={styles.datepickermain}
      calendarClassName={'calendarClass'}
      placeholderText={props.currentLanguage === 'es' ? 'Selección requerida' : 'Selection Required'}
      isClearable={props.selected}
      autoComplete
      popperClassName={'close'}
      ref={ref => (refPicker = ref)}
      onClickOutside={clickOutside}
    />
    <span //eslint-disable-line
      className="Select-arrow-zone"
      onClick={toggleClick}
    >
      <span
        className={`Select-arrow ${styles['Select-arrow-inner']}`}
      />
    </span>
  </div>
);

DatePickerComponent.propTypes = {
  selected: React.PropTypes.string,
  currentLanguage: PropTypes.string
};
export default DatePickerComponent;



// WEBPACK FOOTER //
// ./src/components/DatePickerComponent/DatePickerComponent.js